/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Paper,
  Button,
  Select,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import useStyles from './styles'; // Importa los estilos desde Styles.js
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import { clientAxios8080 } from '../../../../configs/axios';
import LoadingOverlay from "../../../loading-overlay";

// Componente principal
function NodosDetalle() {
  // Aplica los estilos
  const classes = useStyles();

  // Estado para los datos de sitios y el modal
  const [loading, setLoading] = useState(true);
  const [sitios, setSitios] = useState([]);
  const [tipoDispositivos, setTipoDispositivos] = useState([]);
  const [inmuebles, setInmuebles] = useState([]);
  const [criticidades, setCriticidades] = useState([]);
  const [tipoServicios, setTipoServicios] = useState([]);
  const [organizaciones, setOrganizaciones] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSitioId, setModalSitioId] = useState(null);
  const [modalNombre, setModalNombre] = useState('');
  const [modalDireccionIp, setModalDireccionIp] = useState('');
  const [modalTipoDispositivoId, setModalTipoDispositivoId] = useState('');
  const [modalInmuebleId, setModalInmuebleId] = useState('');
  const [modalCriticidadId, setModalCriticidadId] = useState('');
  const [modalTipoServicioId, setModalTipoServicioId] = useState('');
  const [modalOrganizacionId, setModalOrganizacionId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tipoDispositivoIdError, setTipoDispositivoIdError] = useState('');
  const [inmuebleIdError, setInmuebleIdError] = useState('');
  const [criticidadIdError, setCriticidadIdError] = useState('');
  const [tipoServicioIdError, setTipoServicioIdError] = useState('');
  const [organizacionIdError, setOrganizacionIdError] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [direccionIpError, setDireccionIpError] = useState('');
  const [modalFechaCreacion, setModalFechaCreacion] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [modalTipoDispositivoIdSelect, setModalTipoDispositivoIdSelect] = useState('');
  const [modalInmuebleIdSelect, setModalInmuebleIdSelect] = useState('');
  const [modalCriticidadIdSelect, setModalCriticidadIdSelect] = useState('');
  const [modalTipoServicioIdSelect, setModalTipoServicioIdSelect] = useState('');
  const [modalOrganizacionIdSelect, setModalOrganizacionIdSelect] = useState('');
  const [orderBy, setOrderBy] = useState('nodeId'); // Inicialmente, ordena por ID ascendente
  const [orderDirection, setOrderDirection] = useState('asc'); // Inicialmente, en orden ascendente
  const [orderByFechaCreacion, setOrderByFechaCreacion] = useState('asc'); // Inicialmente, ordena por fecha de creación ascendente
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Esto define rowsPerPage y su función para cambiar el valor
  const formattedDate = new Date().toISOString();

  const modalStyle = {
    position: 'absolute',
    width: '50%',
    bgcolor: 'background.paper',
    p: 4,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto',
    maxHeight: '100vh',
  };

  async function getSitio() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/nodo');
      const responseData = response.data.data;
      // Ordena los datos por 'id' de forma predeterminada
      responseData.sort((a, b) => a.nodeId - b.nodeId);
      setSitios(responseData);
      setLoading(false);
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false);
    }
  }
  async function getTipoDispositivo() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/nodo');
      const responseData = response.data.data.filter((tipoDispositivo) => tipoDispositivo.status === true);
      setTipoDispositivos(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getInmueble() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/inmuebleByGrupoAndRegion');
      const responseData = response.data.filter((inmueble) => inmueble.status === true);
      setInmuebles(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getCriticidad() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/criticidad/sitio');
      const responseData = response.data.data.filter((criticidad) => criticidad.status === true);
      setCriticidades(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getTipoServicio() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/tipo/servicios');
      const responseData = response.data.data.filter((tipoServicio) => tipoServicio.status === true);
      setTipoServicios(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getOrganizacion() {
    try {
      const response = await clientAxios8080.get('/ms-catalogos/filtros/organizacion');
      const responseData = response.data.data.filter((organizacion) => organizacion.status === true);
      setOrganizaciones(responseData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const postSitio = async () => {
    try {
      const newSitioData = {
        claveCriticidad: modalCriticidadIdSelect,
        direccionIp: modalDireccionIp,
        dsNodo: modalNombre,
        fechaCreacion: formattedDate,
        inmuebleId: modalInmuebleIdSelect,
        organizacionId: modalOrganizacionIdSelect,
        status: modalStatus,
        tipoDispositivoId: modalTipoDispositivoIdSelect,
        tipoServicioId: modalTipoServicioIdSelect,
      };

      const response = await clientAxios8080.post('/ms-catalogos/filtros/nodo', newSitioData);

      if (response.status === 200) {

        // Show success alert for new record
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro agregado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getSitio()
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text:  response.data.error || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const putSitio = async () => {
    try {
      const updatedSitioData = {
        nodeId: modalSitioId,
        claveCriticidad: modalCriticidadIdSelect,
        direccionIp: modalDireccionIp,
        dsNodo: modalNombre,
        fechaCreacion: formattedDate,
        inmuebleId: modalInmuebleIdSelect,
        organizacionId: modalOrganizacionIdSelect,
        status: modalStatus,
        tipoDispositivoId: modalTipoDispositivoIdSelect,
        tipoServicioId: modalTipoServicioIdSelect,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/nodo/', updatedSitioData);

      if (response.status === 200) {

        // Show success alert for new record
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro agregado con éxito',
          showConfirmButton: false,
          timer: 4200,
        });
        getSitio()
      } else {
        setLoading(false);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response?.data?.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      setLoading(false);
      console.error('Error al enviar la solicitud PUT:', error);
    }
  };

  const deleteSitio = async (nodeId) => {
    try {
      const response = await clientAxios8080.delete(`/ms-catalogos/filtros/nodo?id=${nodeId}`);

      if (response.status === 200) {
        getSitio();
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: response.data.error || 'Hubo un error al procesar la solicitud.',
        });
      }
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error || 'Hubo un error al procesar la solicitud.',
      });
      console.error('Error al enviar la solicitud DELETE:', error);
    }
  };

  useEffect(() => {
    getTipoDispositivo();
    getInmueble();
    getCriticidad();
    getTipoServicio();
    getOrganizacion();
    getSitio();
  }, []);

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setIsModalOpen(true);
    setModalSitioId(null);
    setModalNombre('');
    setNombreError('');
    setModalDireccionIp('');
    setDireccionIpError('');
    setModalTipoDispositivoId('');
    setTipoDispositivoIdError('');
    setModalInmuebleId('');
    setInmuebleIdError('');
    setModalCriticidadId('');
    setCriticidadIdError('');
    setModalTipoServicioId('');
    setTipoServicioIdError('');
    setModalOrganizacionId('');
    setOrganizacionIdError('');
    setModalFechaCreacion(formattedDate);
    setModalStatus(true);
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = (
    nodeId,
    nombre,
    direccionIp,
    tipoDispositivoId,
    inmuebleId,
    criticidadId,
    tipoServicioId,
    organizacionId,
    fechaCreacion,
    status
  ) => {
    setIsModalOpen(true);
    setModalSitioId(nodeId);
    setModalNombre(nombre);
    setModalDireccionIp(direccionIp);
    setModalTipoDispositivoIdSelect(tipoDispositivoId);
    setModalInmuebleIdSelect(inmuebleId);
    setModalCriticidadIdSelect(criticidadId);
    setModalTipoServicioIdSelect(tipoServicioId);
    setModalOrganizacionIdSelect(organizacionId);
    setModalFechaCreacion(fechaCreacion);
    setModalStatus(status);
    setNombreError('');
    setDireccionIpError('');
    setTipoDispositivoIdError('');
    setInmuebleIdError('');
    setCriticidadIdError('');
    setTipoServicioIdError('');
    setOrganizacionIdError('');
  };

  // Maneja el cambio en el campo "Nombre"
  const handleNombreChange = (e) => {
    console.log('handleNombreChange function called');
    const newName = e.target.value;
    setModalNombre(newName);

    if (newName.trim().length === 0) {
      setNombreError('El nombre no puede estar vacío.');
    } else if (newName.trim().length < 3) {
      setNombreError('El nombre debe tener al menos 3 caracteres.');
    } else {
      const textRegex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.,]*$/;

      if (textRegex.test(newName)) {
        setNombreError('');
      } else {
        setNombreError('El texto contiene caracteres no permitidos.')
      }
    }
  };

  const handleDireccionIpChange = (e) => {
    const newDireccionIp = e.target.value;
    setModalDireccionIp(newDireccionIp);

    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/; // Expresión regular para validar una dirección IP

    if (newDireccionIp.trim().length === 0) {
      setDireccionIpError('La dirección IP no puede estar vacía.');
    } else if (!ipRegex.test(newDireccionIp)) {
      setDireccionIpError('La dirección IP debe tener un formato válido (por ejemplo, 192.168.1.1).');
    } else {
      setDireccionIpError('');
    }
  };

  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (nodeId) => {
    try {
      // Busca el sitio en el estado actual
      const sitioToUpdate = sitios.find((sitio) => sitio.nodeId === nodeId);

      // Realiza el cambio localmente en el estado
      setSitios((prevSitios) =>
        prevSitios.map((sitio) => {
          if (sitio.nodeId === nodeId) {
            const updatedSitioData = { ...sitio, status: !sitio.status };
            console.log('Status cambiado:', updatedSitioData); // Mostrar el arreglo actualizado
            return updatedSitioData;
          }
          return sitio;
        })
      );
      // Aquí se debe acceder directamente a sitioToUpdate en lugar de intentar acceder a sitio fuera del bloque map
      const updatedSitioData = {
        nodeId: sitioToUpdate.nodeId,
        claveCriticidad: sitioToUpdate.claveCriticidad,
        direccionIp: sitioToUpdate.direccionIp,
        dsNodo: sitioToUpdate.dsNodo,
        fechaCreacion: sitioToUpdate.fechaCreacion,
        inmuebleId: sitioToUpdate.inmuebleId,
        organizacionId: sitioToUpdate.organizacionId,
        status: !sitioToUpdate.status,
        tipoDispositivoId: sitioToUpdate.tipoDispositivoId,
        tipoServicioId: sitioToUpdate.tipoServicioId,
      };

      const response = await clientAxios8080.put('/ms-catalogos/filtros/nodo/', updatedSitioData);
      console.log('Datos que se enviarán en la solicitud PUT:', updatedSitioData);

      if (response.status === 200) {
        console.log('Sitio actualizado exitosamente.');
        const title = updatedSitioData.status ? 'Sitio activado exitosamente.' : 'Sitio desactivado exitosamente.';
        Swal.fire({
          position: 'center',
          icon: 'success',
          title,
          showConfirmButton: false,
          timer: 1200,
        });
        getSitio()
      } else {
        console.error('Error al actualizar el sitio:', response.data.error);
      }
    } catch (error) {
      console.error('Error al enviar la solicitud PUT:', error);
    }
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    setLoading(true);
    const tipoDispositivoIdToSave = modalTipoDispositivoIdSelect;
    const inmuebleIdToSave = modalInmuebleIdSelect;
    const criticidadIdToSave = modalCriticidadIdSelect;
    const tipoServicioIdToSave = modalTipoServicioIdSelect;
    const organizacionIdToSave = modalOrganizacionIdSelect;

    let newTipoDispositivoIdError = '';
    let newInmuebleIdError = '';
    let newCriticidadIdError = '';
    let newTipoServicioIdError = '';
    let newOrganizacionIdError = '';
    let newNombreError = '';
    let newDireccionIpError = '';

    if (!tipoDispositivoIdToSave) {
      newTipoDispositivoIdError = 'Debe seleccionar un tipo de dispositivo.';
    }
    if (!inmuebleIdToSave) {
      newInmuebleIdError = 'Debe seleccionar un inmueble.';
    }
    if (!criticidadIdToSave) {
      newCriticidadIdError = 'Debe seleccionar una criticidad.';
    }
    if (!tipoServicioIdToSave) {
      newTipoServicioIdError = 'Debe seleccionar un tipo de servicio.';
    }
    if (!organizacionIdToSave) {
      newOrganizacionIdError = 'Debe seleccionar una organización.';
    }
    if (modalNombre.trim().length === 0) {
      newNombreError = 'El nombre no puede estar vacío.';
    } else if (modalNombre.trim().length < 3) {
      newNombreError = 'El nombre debe tener al menos 3 caracteres.';
    }
    if (modalDireccionIp.trim().length === 0) {
      newDireccionIpError = 'La dirección Ip no puede estar vacía.';
    } else if (modalDireccionIp.trim().length < 3) {
      newDireccionIpError = 'La dirección Ip debe tener al menos 3 caracteres.';
    }

    setTipoDispositivoIdError(newTipoDispositivoIdError);
    setInmuebleIdError(newInmuebleIdError);
    setCriticidadIdError(newCriticidadIdError);
    setTipoServicioIdError(newTipoServicioIdError);
    setOrganizacionIdError(newOrganizacionIdError);
    setNombreError(newNombreError);
    setDireccionIpError(newDireccionIpError);

    if (
      !newTipoDispositivoIdError &&
      !newNombreError &&
      !newDireccionIpError &&
      !newInmuebleIdError &&
      !newCriticidadIdError &&
      !newTipoServicioIdError &&
      !newOrganizacionIdError
    ) {
      try {
        if (modalSitioId !== null) {
          // Update existing site
          await putSitio();
          
        } else {
          // Add new site
          await postSitio();
        }

        // Close the modal and reset the fields
        setIsModalOpen(false);
        setModalSitioId(null);
        setModalNombre('');
        setModalDireccionIp('');
        setModalTipoDispositivoIdSelect('');
        setTipoDispositivoIdError('');
        setModalInmuebleIdSelect('');
        setInmuebleIdError('');
        setModalCriticidadIdSelect('');
        setCriticidadIdError('');
        setModalTipoServicioIdSelect('');
        setTipoServicioIdError('');
        setModalOrganizacionIdSelect('');
        setOrganizacionIdError('');
        if (modalNombre.trim().length >= 3) {
          setNombreError('');
        }
        if (modalDireccionIp.trim().length >= 3) {
          setDireccionIpError('');
        }
        getSitio();
      } catch (error) {
        // Show error alert
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error al procesar la solicitud',
          text: error.message || 'Hubo un error al procesar la solicitud.',
        });
        setLoading(false);
      }
    }
  };

  /// Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = (nodeId) => {
    setLoading(true);
    const sitio = sitios.find((i) => i.nodeId === nodeId); // Encuentra el sitio por su ID

    Swal.fire({
      title: `Estás a punto de eliminar el sitio: "${sitio.dsNodo}".`,
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteSitio(nodeId);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro eliminado con éxito.',
            showConfirmButton: false,
            timer: 2000,
          });
        } catch (error) {
          setLoading(false);
          console.error('Error al eliminar el inmueble:', error);

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el registro.',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      }
    });
  };

  const handleOrderByChange = (newOrderBy) => {
    if (newOrderBy === orderBy) {
      // Si se hace clic en la misma columna, cambia la dirección del orden
      setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Si se hace clic en una nueva columna, establece la columna de orden y el orden ascendente
      setOrderBy(newOrderBy);
      setOrderDirection('asc'); // Siempre ordena por 'id' en orden ascendente cuando cambia la columna
    }
  };

  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const filteredSitios = sitios.filter((sitio) => {
    const searchValueWithoutAccents = removeAccents(searchValue.toLowerCase());

    return (
      removeAccents(sitio.dsNodo.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.direccionIp.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.dsTipoDispositivo.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.dsInmueble.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.dsCsriticidad.toLowerCase()).includes(searchValueWithoutAccents) ||
      removeAccents(sitio.dsTipoServicio.toLowerCase()).includes(searchValueWithoutAccents)
    );
  });
  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Detalle del Catálogo para Nodos</h1>
      <div className={classes.addButtonStyle}>
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <div className={classes.selectContainer}>
          <Select id="rows-per-page-select" value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
            <MenuItem value={10}>Mostrar 10 elementos</MenuItem>
            <MenuItem value={30}>Mostrar 30 elementos</MenuItem>
            <MenuItem value={sitios.length}>Todos los elementos</MenuItem>
          </Select>
        </div>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} style={{ tableLayout: 'auto' }}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center" onClick={() => handleOrderByChange('nodeId')}>
                Id {orderBy === 'nodeId' && <span>{orderDirection === 'asc' ? '▲' : '▼'}</span>}
              </TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Direccion Ip</TableCell>
              <TableCell align="center">Tipo de Dispositivo</TableCell>
              <TableCell align="center">Inmueble</TableCell>
              <TableCell align="center">Criticidad</TableCell>
              <TableCell align="center">Tipo de Servicio</TableCell>
              <TableCell align="center">Organización</TableCell>
              <TableCell align="center">Fecha de Creación</TableCell>
              <TableCell align="center">Estatus</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredSitios.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              filteredSitios
                .slice(page * rowsPerPage, (page + 1) * rowsPerPage) // Filtrar las filas según la página actual
                .sort((a, b) => {
                  // Ordenar según la columna seleccionada y la dirección del orden
                  if (orderBy === 'nodeId') {
                    return orderDirection === 'asc' ? a.nodeId - b.nodeId : b.nodeId - a.nodeId;
                  }
                  return 0;
                })
                .map((sitio) => (
                  <TableRow key={sitio.nodeId}>
                    <TableCell align="center">{sitio.nodeId}</TableCell>
                    <TableCell align="center">{sitio.dsNodo}</TableCell>
                    <TableCell align="center">{sitio.direccionIp}</TableCell>
                    <TableCell align="center">{sitio.dsTipoDispositivo}</TableCell>
                    <TableCell align="center">{sitio.dsInmueble}</TableCell>
                    <TableCell align="center">{sitio.dsCsriticidad}</TableCell>
                    <TableCell align="center">{sitio.dsTipoServicio}</TableCell>
                    <TableCell align="center">{sitio.organizacion}</TableCell>
                    <TableCell align="center">{format(new Date(Number(sitio.fechaCreacion)), 'yyyy-MM-dd')}</TableCell>
                    <TableCell align="center">
                      <div className={classes.centeredSwitch}>
                        <Switch checked={sitio.status} onChange={() => handleStatusChange(sitio.nodeId)} className={classes.customSwitch} />
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                        <img
                          src={editarImage}
                          alt="Editar"
                          className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                          onClick={() =>
                            handleEditarClick(
                              sitio.nodeId,
                              sitio.dsNodo,
                              sitio.direccionIp,
                              sitio.tipoDispositivoId,
                              sitio.inmuebleId,
                              sitio.claveCriticidad,
                              sitio.tipoServicioId,
                              sitio.organizacionId,
                              sitio.fechaCreacion,
                              sitio.status
                            )
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                        <img
                          src={eliminarImage}
                          alt="Eliminar"
                          className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                          onClick={() => handleEliminarClick(sitio.nodeId)}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className={classes.pagination}>
            <IconButton onClick={() => setPage(0)} disabled={page === 0} aria-label="Primera página">
              <FirstPageIcon />
            </IconButton>
            <IconButton onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0} aria-label="Página anterior">
              <NavigateBeforeIcon />
            </IconButton>
            <span>
              {page + 1} de {Math.ceil(sitios.length / rowsPerPage)}
            </span>
            <IconButton
              onClick={() => setPage(Math.min(page + 1, Math.floor(sitios.length / rowsPerPage)))}
              disabled={page >= Math.floor(sitios.length / rowsPerPage)}
              aria-label="Página siguiente"
            >
              <NavigateNextIcon />
            </IconButton>
            <IconButton
              onClick={() => setPage(Math.floor(sitios.length / rowsPerPage))}
              disabled={page >= Math.floor(sitios.length / rowsPerPage)}
              aria-label="Última página"
            >
              <LastPageIcon />
            </IconButton>
          </div>
        </div>
      </TableContainer>
      {loading && <LoadingOverlay />}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={modalStyle}>
          <h2>{modalSitioId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <TextField
            label="Nombre"
            variant="outlined"
            value={modalNombre}
            onChange={handleNombreChange}
            className={classes.modalTextField}
            error={nombreError !== ''}
            helperText={nombreError}
          />
          <TextField
            label="Direccion Ip"
            variant="outlined"
            value={modalDireccionIp}
            onChange={handleDireccionIpChange}
            className={classes.modalTextField}
            error={direccionIpError !== ''}
            helperText={direccionIpError}
          />
          <FormControl className={classes.modalTextField} error={Boolean(tipoDispositivoIdError)}>
            <InputLabel
              id="tipodispositivo-select-label"
              htmlFor="tipodispositivo-select"
              {...(tipoDispositivoIdError ? { style: { color: 'red' } } : {})}
            >
              Tipo de Dispositivo
            </InputLabel>
            <Select
              labelId="tipodispositivo-select-label"
              id="tipodispositivo-select"
              value={modalTipoDispositivoIdSelect}
              onChange={(e) => setModalTipoDispositivoIdSelect(e.target.value)}
            >
              {tipoDispositivos.map((tipoDispositivo) => (
                <MenuItem key={tipoDispositivo.tipoDispositivoId} value={tipoDispositivo.tipoDispositivoId}>
                  {tipoDispositivo.dsTipoDispositivo}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{tipoDispositivoIdError}</FormHelperText>
          </FormControl>
          <FormControl className={classes.modalTextField} error={Boolean(inmuebleIdError)}>
            <InputLabel id="inmueble-select-label" htmlFor="inmueble-select" {...(inmuebleIdError ? { style: { color: 'red' } } : {})}>
              Inmueble
            </InputLabel>
            <Select
              labelId="inmueble-select-label"
              id="inmueble-select"
              value={modalInmuebleIdSelect}
              onChange={(e) => setModalInmuebleIdSelect(e.target.value)}
            >
              {inmuebles.map((inmueble) => (
                <MenuItem key={inmueble.inmuebleId} value={inmueble.inmuebleId}>
                  {inmueble.dsInmueble}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{inmuebleIdError}</FormHelperText>
          </FormControl>
          <FormControl className={classes.modalTextField} error={Boolean(criticidadIdError)}>
            <InputLabel
              id="criticidad-select-label"
              htmlFor="criticidad-select"
              {...(criticidadIdError ? { style: { color: 'red' } } : {})}
            >
              Criticidad
            </InputLabel>
            <Select
              labelId="criticidad-select-label"
              id="criticidad-select"
              value={modalCriticidadIdSelect}
              onChange={(e) => setModalCriticidadIdSelect(e.target.value)}
            >
              {criticidades.map((criticidad) => (
                <MenuItem key={criticidad.claveCriticidadSitio} value={criticidad.claveCriticidadSitio}>
                  {criticidad.dsCriticidadSitio}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{criticidadIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(tipoServicioIdError)}>
            <InputLabel
              id="tiposervicio-select-label"
              htmlFor="tiposervicio-select"
              {...(tipoServicioIdError ? { style: { color: 'red' } } : {})}
            >
              Tipo de Servicio
            </InputLabel>
            <Select
              labelId="tiposervicio-select-label"
              id="tiposervicio-select"
              value={modalTipoServicioIdSelect}
              onChange={(e) => setModalTipoServicioIdSelect(e.target.value)}
            >
              {tipoServicios.map((tipoServicio) => (
                <MenuItem key={tipoServicio.tipoServicioId} value={tipoServicio.tipoServicioId}>
                  {tipoServicio.dsTipoServicio}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{tipoServicioIdError}</FormHelperText>
          </FormControl>

          <FormControl className={classes.modalTextField} error={Boolean(organizacionIdError)}>
            <InputLabel
              id="organizacion-select-label"
              htmlFor="organizacion-select"
              {...(organizacionIdError ? { style: { color: 'red' } } : {})}
            >
              Organización
            </InputLabel>
            <Select
              labelId="organizacion-select-label"
              id="organizacion-select"
              value={modalOrganizacionIdSelect}
              onChange={(e) => setModalOrganizacionIdSelect(e.target.value)}
            >
              {organizaciones.map((organizacion) => (
                <MenuItem key={organizacion.organizacionId} value={organizacion.organizacionId}>
                  {organizacion.organizacion}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText className={classes.errorText}>{organizacionIdError}</FormHelperText>
          </FormControl>

          <div className={classes.modalButtons}>
            <Button variant="contained" color="primary" onClick={handleGuardarClick} className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setIsModalOpen(false)} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default NodosDetalle;
